import styled from 'styled-components';
import { ErrorScreenStyleProps } from './types';

export const Wrapper = styled('div')<ErrorScreenStyleProps>`
  display: flex;
  flex-direction: column;
  min-height: ${props => (props.height ? `${props.height}vh` : '90vh')};
  width: 100%;
  justify-content: center;
  align-items: center;

  svg {
    font-size: 1em;
    margin-bottom: 3rem;
  }
  h3,
  p {
    font-family: 'Inter', sans-serif;
  }

  h3 {
    color: #000;
    font-weight: 700;
    font-size: 24px;
    margin: 0;
  }
  p {
    color: #8c92a2;
    font-weight: 500;
    font-size: 18px;
  }

  button {
    margin-top: 1rem;
  }
`;
